import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export type CustomerRow = { id: string; name: string };

type RedirectToConnectionsDeps = {
  router: { push: (location: string) => unknown };
  setCustomer?: (payload: CustomerRow) => unknown;
  isConnectionsV2Available: boolean;
};

export const redirectToConnections = (
  row: CustomerRow,
  { router, setCustomer, isConnectionsV2Available }: RedirectToConnectionsDeps,
) => {
  setCustomer?.(row);
  const suffix = isConnectionsV2Available
    ? "settings/connections-v2"
    : "settings/connections";
  return router.push(buildOrgUrl("customer", row.id, suffix));
};

export const redirectToConnectionsV2 = (
  row: CustomerRow,
  {
    router,
    setCustomer,
  }: Omit<RedirectToConnectionsDeps, "isConnectionsV2Available">,
) => {
  setCustomer?.(row);
  return router.push(
    buildOrgUrl("customer", row.id, "settings/connections-v2"),
  );
};
